module.exports = __webpack_public_path__ + "img/thumbnail.2479f342.jpg";